module.exports = __webpack_public_path__ + "img/rocketship-1.49eeb50d.jpg";